import { PageLayout } from '@components/PageLayout/PageLayout';
import { NextPage } from 'next';
import s from './collectionsPage.module.scss';
import cn from 'classnames';
import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import { useTranslation } from '@hooks/useTranslation';
import { CollectionsList } from '@components/Pages/CollectionPage/CollectionsList/CollectionsList';
import { Search } from '@components/UIKit/Search/Search';
import { CollectionWeekCard } from '@components/Cards/CollectionWeekCard/CollectionWeekCard';
import { useRouter } from 'next/router';
import { PageQueries } from '@specs/navigation';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => ({
  ...props
}));
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = () => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    query
  } = router.query as PageQueries;
  return <PageLayout showBackIconOnMobile data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.collectionPage}>
                <div className={cn(s.collectionPage__container, '_container')}>
                    <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                    <div className={s.collectionPage__top}>
                        <div className={cn(s.collectionPage__title, '_title')}>
                            {tr({
              id: 'collections.page.title'
            })}
                        </div>
                    </div>
                    <Search boxClassName={s.collectionPage__search} placeholder={tr({
          id: 'enter.collection.name'
        })} name={'toys'} data-sentry-element="Search" data-sentry-source-file="index.tsx" />
                    {!query ? <CollectionWeekCard className={s.collectionPage__collectionWeekCard} /> : null}

                    <div className={s.collectionPage__main}>
                        <h3 className={s.collectionPage__subtitle}>{tr({
              id: 'collections.page.trending.collections.title'
            })}</h3>
                        <CollectionsList data-sentry-element="CollectionsList" data-sentry-source-file="index.tsx" />
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default Page;